// extracted by mini-css-extract-plugin
module.exports = {"seriesHome":"style_seriesHome__R2PRJ"};